import { debounce } from './debounce'
class DeviceDetector {
  constructor() {
    this.width = typeof window !== 'undefined' ? window.innerWidth : 1024;
    this.callbacks = new Set();
    this.observer = null;

    if (typeof window !== 'undefined') {
      // 创建防抖的通知函数
      this.debouncedNotify = debounce(() => {
        this.notify();
      }, 16); // 约等于一帧的时间

      this.observer = new ResizeObserver(() => {
        const newWidth = window.innerWidth;
        if (this.width !== newWidth) {
          this.width = newWidth;
          this.debouncedNotify();
        }
      });

      // 只观察 body 元素，而不是整个 documentElement
      this.observer.observe(document.body);
      this.init();
    }
  }

  init () {
    // 使用防抖处理方向变化
    const handleOrientationChange = debounce(() => {
      this.updateWidth();
    }, 100);

    window.addEventListener('orientationchange', handleOrientationChange);

    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) {
        this.updateWidth();
      }
    });
  }

  updateWidth () {
    const newWidth = window.innerWidth;
    if (this.width !== newWidth) {
      this.width = newWidth;
      this.debouncedNotify();
    }
  }

  subscribe (callback) {
    this.callbacks.add(callback);
    // 立即执行一次回调，确保初始状态正确
    callback(this.width);

    return () => {
      this.callbacks.delete(callback);
    };
  }

  notify () {
    this.callbacks.forEach(callback => callback(this.width));
  }

  isPC () {
    return this.width > 750;
  }

  isMobile () {
    return this.width <= 750;
  }

  getWidth () {
    return this.width;
  }

  forceUpdate () {
    this.updateWidth();
  }

  // 销毁方法，用于清理监听器
  destroy () {
    if (this.observer) {
      this.observer.disconnect();
    }
    this.callbacks.clear();
  }
}

const deviceDetector = new DeviceDetector();

export default deviceDetector;